import { Box } from '@material-ui/core';
import { Dialog } from 'src/components/Dialog';
import { PDFViewer } from '@react-pdf/renderer';
import { timeString } from 'src/helpers';
import CertificatePdf from 'src/modules/Private/Courses/CertificateDialog/CertificatePdf';
import moment from 'moment';

interface CertificateDialogProps {
	open: boolean;
	handleOpen: () => void;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	certificate?: any;
	institutionName: string;
}

export function CertificateDialog({
	certificate,
	handleOpen,
	institutionName,
	open,
}: CertificateDialogProps) {
	return (
		<Dialog
			content={
				<Box display={'flex'} flexDirection={'column'} height={'100%'}>
					<Box flexGrow={1}>
						<PDFViewer
							height={'100%'}
							style={{ border: 'none' }}
							width={'100%'}
						>
							<CertificatePdf
								courseName={certificate.courseName || ''}
								date={moment(certificate.date).format(
									'MMMM DD, YYYY',
								)}
								department={certificate.department || ''}
								duration={timeString(certificate.duration)}
								institutionName={institutionName || ''}
								name={certificate.user || ''}
								qualification={certificate.qualification}
								showInstitution
								showPosition
							/>
						</PDFViewer>
					</Box>
				</Box>
			}
			fullScreen
			handleOpen={handleOpen}
			maxWidth={'xl'}
			noPadding
			open={open}
			title={'Certificado'}
		/>
	);
}
